import React from 'react';
import { DataImporter } from '@ingestro/importer-react';

import config from '@epi-config';

const { ingestroLicenseKey } = config;

export const IngestroImporter = () => {
  return (
    <DataImporter
      licenseKey={ingestroLicenseKey || 'no license key'}
      settings={{
        modal: false,
        identifier: 'User mass upload',
        developerMode: true,
        allowManualInput: true,
        enableExamples: false,
        automaticHeaderDetection: false,
        allowCustomColumns: true,
        onlyMappedColumns: false,
        disableExcelTemplate: false,
        disableTemplates: true,
        automaticMapping: false,
        multipleFileUpload: true,
        smartTable: true,
        cleaningAssistant: false,
        completeImportAction: 'discard',
        language: 'en',
        inputTypes: ['pdf', 'json', 'xml', 'csv', 'xlsx', 'xls'],
        contextualEngine: 'disabled',
        columnMappingConfiguration: {
          threshold: 0.6,
          layers: ['exact', 'historic', 'smart', 'fuzzy'],
          processingMode: 'node'
        },
        prompts: true,
        transpose: false,
        mappingViewMode: 'sourceColumns',
        columns: [
          {
            label: 'Company ID',
            key: 'company_id',
            description: 'Company number with 8 digits ',
            example: '90000001',
            columnType: 'int',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Company ID is required'
              }
            ],
            dropdownOptions: null,
            alternativeMatches: [],
            isMultiSelect: false,
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Company name',
            key: 'company_name',
            description: 'Name of the company',
            example: 'Edenred',
            columnType: 'string',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Company name is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'First name',
            key: 'first_name',
            description: 'Employee first name',
            example: 'Mika',
            columnType: 'string',
            validations: [
              {
                validate: 'required',
                errorMessage: 'First name is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Last name',
            key: 'last_name',
            description: 'Employees last name',
            example: 'Ahosilta',
            columnType: 'string',
            validations: [
              {
                validate: 'required',
                errorMessage: 'last name is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Personal ID',
            key: 'personal_id',
            description: 'Employee SSN',
            example: '11111977-123K',
            columnType: 'string',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Personal ID is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Email address',
            key: 'email_address',
            description: 'Employee email address',
            example: 'firstname.lastname@company.com',
            columnType: 'email',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Email address is required'
              }
            ],
            dropdownOptions: null,
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Employee number',
            key: 'employee_number',
            description: 'Internal employee number',
            example: 'A123',
            columnType: 'string',
            validations: null,
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Cost center number',
            key: 'cost_center_number',
            description: "Number of employee's cost center",
            example: '123A',
            columnType: 'string',
            validations: null,
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Employment type',
            key: 'employment_type',
            example: null,
            columnType: 'category',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Employment type is required'
              }
            ],
            dropdownOptions: [
              {
                label: 'Full time',
                description: 'Full time employees',
                alternativeMatches: [],
                type: 'string',
                value: 'full_time'
              },
              {
                label: 'Part time',
                description: 'part time employees',
                alternativeMatches: [],
                type: 'string',
                value: 'part_time'
              },
              {
                label: 'Temporarily employed',
                description: 'For temporary employees',
                alternativeMatches: [],
                type: 'string',
                value: 'temporarily_employed'
              },
              {
                label: 'Dropped',
                description: 'Employees already dropped',
                alternativeMatches: [],
                type: 'string',
                value: 'dropped'
              },
              {
                label: 'On hold',
                description: 'Employees temporarily on hold',
                alternativeMatches: [],
                type: 'string',
                value: 'on_hold'
              }
            ],
            alternativeMatches: [],
            isMultiSelect: false,
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            optionMappingConfiguration: {
              layers: ['exact', 'fuzzy'],
              threshold: 0.6,
              processingMode: 'browser'
            },
            hidden: false,
            disabled: false
          },
          {
            label: 'Working hours percentage',
            key: 'working_hours_percentage',
            description: 'Percentage of full hours the employee is working',
            example: '50',
            columnType: 'percentage',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Working hours percentage is required'
              }
            ],
            dropdownOptions: null,
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Lunch benefit monthly days',
            key: 'lunch_benefit_monthly_days',
            description: 'Days of month the employee gets lunch benefit',
            example: '20',
            columnType: 'int',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Lunch benefit monthly days is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Benefits start date',
            key: 'benefits_start_date',
            description: 'Date when benefit is entitled to benefits',
            example: '1.1.2026',
            columnType: 'date',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Benefits start date is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Employment end date',
            key: 'employment_end_date',
            description: 'Date when the employees employment ends',
            example: '1.1.2027',
            columnType: 'date',
            validations: null,
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          },
          {
            label: 'Benefit group',
            key: 'benefit_group',
            description: 'Name of the employees benefit group',
            example: 'Lunch',
            columnType: 'string',
            validations: [
              {
                validate: 'required',
                errorMessage: 'Benefit group is required'
              }
            ],
            dropdownOptions: [],
            alternativeMatches: [],
            allowCustomOptions: false,
            numberFormat: 'eu',
            outputFormat: null,
            hidden: false,
            disabled: false
          }
        ],
        style: {
          globals: {
            primaryColor: '#223286',
            secondaryColor: '#eeeeee',
            primaryTextColor: '#373737',
            secondaryTextColor: '#373737',
            fontFamily: 'Montserrat'
          }
        }
      }}
      stepHandler={{
        mappingStep: async ({ data, tdm, updateData, alert, block, logs }) => {
          tdm.addColumn({
            key: 'status',
            label: 'Validation status',
            columnType: 'string'
          });
        }
      }}
      onCancel={() => {
        console.log('onCancel');
      }}
      onResults={(result, errors, complete) => {
        console.log('Result:', result);
        console.log('Error rows:', errors);
        complete();
      }}
    />
  );
};
